import fs from 'node:fs'
import path from 'node:path'
import { LOCAL_PROTOCOL_PATTERN } from '@cli-constants/patterns.js'

export function guardPackageJson(
  cwd: string,
  restores: Array<() => void>
): { localSpecDeps: string[]; removedCliDep: boolean } {
  const packageJsonPath = path.join(cwd, 'package.json')
  if (!fs.existsSync(packageJsonPath)) {
    return { localSpecDeps: [], removedCliDep: false }
  }

  const original = fs.readFileSync(packageJsonPath, 'utf-8')
  let parsed: Record<string, unknown>
  try {
    parsed = JSON.parse(original) as Record<string, unknown>
  } catch {
    return { localSpecDeps: [], removedCliDep: false }
  }

  const localSpecDeps: string[] = []
  let removedCliDep = false

  for (const section of ['dependencies', 'devDependencies'] as const) {
    const deps = parsed[section]
    if (!deps || typeof deps !== 'object') continue
    const record = deps as Record<string, unknown>

    if ('betterstart-cli' in record) {
      Reflect.deleteProperty(record, 'betterstart-cli')
      removedCliDep = true
    }

    for (const [name, spec] of Object.entries(record)) {
      if (typeof spec === 'string' && LOCAL_PROTOCOL_PATTERN.test(spec)) {
        localSpecDeps.push(name)
      }
    }
  }

  if (removedCliDep) {
    fs.writeFileSync(packageJsonPath, `${JSON.stringify(parsed, null, 2)}\n`, 'utf-8')
    restores.push(() => fs.writeFileSync(packageJsonPath, original, 'utf-8'))
  }

  return { localSpecDeps, removedCliDep }
}
